import QuoteDetailsView from 'text!edge/quoteandbind/common/views/quote-details.html';
import PaymentDetailsView from 'text!edge/quoteandbind/common/views/payment-details.html';
import ContactUsView from 'text!edge/quoteandbind/common/views/contact-us.html';
import ConfirmationView from 'text!edge/quoteandbind/common/views/confirmation.html';
import ZipCodeView from 'text!edge/quoteandbind/common/views/zip-code.html';
import QuoteEntryView from 'text!edge/quoteandbind/common/views/quote-entry.html';
import QuoteEntryCtrl from 'edge/quoteandbind/common/controllers/QuoteEntryCtrl';
import QuoteDetailsCtrl from 'edge/quoteandbind/common/controllers/QuoteDetailsCtrl';
import PaymentDetailsCtrl from 'edge/quoteandbind/common/controllers/PaymentDetailsCtrl';
import ContactUsCtrl from 'edge/quoteandbind/common/controllers/ContactUsCtrl';
import ConfirmationCtrl from 'edge/quoteandbind/common/controllers/ConfirmationCtrl';
import ZipCodeCtrl from 'edge/quoteandbind/common/controllers/ZipCodeCtrl';
import 'gw-portals-featuredetection-js/ApplicationFeatures';

export default (function (RootStates) {

    var parentState = RootStates.quote_bind;
    var wizardParentState = 'baseTransactionWizard';

    return {
        zipCode: {
            name: 'zipCode',
            parent: parentState,
            url: '/zipCode?account',
            controller: ZipCodeCtrl,
            template: ZipCodeView,
            data: {
                trackingUrl: '^/'
            }
        },

        ampquoteentry: {
            parent: parentState,
            url: '/ampquoteentry?quoteID&postalCode',
            controller: ['$state', '$stateParams', function ($state, $stateParams) {
                $state.go('quoteentry', {
                    quoteID: $stateParams.quoteID,
                    postalCode: $stateParams.postalCode,
                    displayYourInfoStep: true
                });
            }]
        },

        quoteentry: {
            parent: parentState,
            url: '/quoteentry',
            controller: QuoteEntryCtrl,
            template: QuoteEntryView,
            params: {
                quoteID: null, // provided when resuming a draft submission
                postalCode: null, // provided when resuming or starting a submission
                productCode: null, // provided when starting a submission
                effectiveDate: null, // provided when starting a submission
                gatewayportalnewsubmission: null, // provided when starting a quote from gateway,
                displayYourInfoStep: null, // provided when resuming a draft submission from a URL, e.g. from AMP
                account: null, // provided when starting a quote from amp
                shouldUpdateEffectiveDate: null // provided when starting a quote from qnb
            },
            resolve: {
                originState: ['$state', function ($state) {
                    // remember the state we came from so we can return if there is an error loading the claim
                    return {
                        name: $state.current,
                        params: $state.params
                    };
                }]
            },
            data: {
                trackingUrl: function trackingUrl(state, params) {
                    return '/quoteentry/' + params.productCode;
                }
            }
        },

        quoteDetails: {
            name: 'quoteDetails',
            parent: wizardParentState,
            controller: QuoteDetailsCtrl,
            template: QuoteDetailsView
        },

        paymentDetails: {
            name: 'paymentDetails',
            parent: wizardParentState,
            template: PaymentDetailsView,
            controller: PaymentDetailsCtrl
        },

        contactUs: {
            name: 'contactUs',
            url: '/contactus',
            parent: parentState,
            controller: ContactUsCtrl,
            template: ContactUsView,
            params: {
                returnStateInfo: null,
                quoteID: null
            },
            data: {
                trackingUrl: '^'
            }
        },

        qnbconfirmation: {
            name: 'confirmation',
            url: '/qnbconfirmation',
            parent: parentState,
            controller: ConfirmationCtrl,
            template: ConfirmationView,
            params: {
                returnStateInfo: null,
                quoteSummary: null
            },
            data: {
                trackingUrl: function trackingUrl(state, params) {
                    return '/qnbconfirmation/' + params.quoteSummary.baseData.productCode;
                }
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/config/RouteConfig.js
// module id = 2111
// module chunks = 0